module.exports = __webpack_public_path__ + "static/img/vip-infos.7b4a5457.png";